import {
  HIDE_CAMPAIGN_CUSTOM_NAMES_LIST_LOADER,
  SET_CAMPAIGN_CUSTOM_NAME_PROFILE,
  SET_CAMPAIGN_CUSTOM_NAMES_LIST,
  SET_ERROR_CAMPAIGN_CUSTOM_NAME_PROFILE,
  SHOW_CAMPAIGN_CUSTOM_NAMES_LIST_LOADER
} from "./actionTypes";

const INIT_STATE = {
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: []
  },
  profileData: [],
  isError: false,
  loading: false,
  // success: null,
  error: null
}

const CampaignCustomNamesList = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_CAMPAIGN_CUSTOM_NAMES_LIST:
      return {
        ...state,
        data: action.payload
      }
    case SHOW_CAMPAIGN_CUSTOM_NAMES_LIST_LOADER:
      return {
        ...state,
        loading: true
      }
    case HIDE_CAMPAIGN_CUSTOM_NAMES_LIST_LOADER:
      return {
        ...state,
        loading: false
      }
    case SET_CAMPAIGN_CUSTOM_NAME_PROFILE:
      return {
        ...state,
        profileData: action.payload
      }
    case SET_ERROR_CAMPAIGN_CUSTOM_NAME_PROFILE:
      return {
        ...state,
        isError: action.payload
      }
    default:
      return state
  }
}

export default CampaignCustomNamesList;
